import { Injectable, signal } from "@angular/core";
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class LocationRegionBridgeService {
    type = signal<string>('');
    city = signal<string>('');
    search_id = signal<string>('');
    location = signal<number>(0);
    searchedItem = signal<string>('');
    location_travel = signal<number>(449);
    page = signal<number>(1);
    last_page = signal<number>(0);
    current_page = signal<number>(0);
    at_home = signal<boolean>(false);
    currentIW = signal<string>('');
    previousIW = signal<string>('');
    slug = signal<string>('');
    placeSlug = signal<string>('');
    result = signal<any>('');
    category_id = signal<any>(0);
    price_filter_search = signal<any>([]);

    constructor(private router: Router,) {

    }

    setType(value) {
        this.type.set(value);
    }

    setCity(value: any) {
        this.city.set(value);
    }

    setSearchId(value: any) {
        this.search_id.set(value);
    }

    setLocation(value: any) {
        this.location.set(value);
    }

    setLocationTravel(value: any) {
        this.location_travel.set(value);
    }

    setPage(value: number) {
        this.page.set(value);
    }

    setLastPage(value: number) {
        this.last_page.set(value);
    }

    setCurrentPage(value: number) {
        this.current_page.set(value);
    }

    setSearchedItem(value: any) {
        this.searchedItem.set(value);
    }

    setAtHome(value: any) {
        this.at_home.set(value);
    }

    setSlug(value: any) {
        // this.router.navigate(['location-region/' + value])
        this.slug.set(value);
    }

    setPlaceSlug(value: any) {
        this.placeSlug.set(value);
    }

    setCategoryId(value: any) {
        this.category_id.set(value);
    }

    setPriceFilter(value: any) {
        this.price_filter_search.set(value);
    }

    setResult(value: any) {
        this.result.set(value);
    }
}